import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-pacces-ebony text-white p-6 font-sans">
          <div className="max-w-md w-full space-y-8 text-center">
            <h1 className="text-4xl font-serif text-pacces-gold">Algo deu errado.</h1>
            <p className="text-stone-400 font-light leading-relaxed">
              Ocorreu um erro inesperado ao carregar a página. Por favor, tente recarregar ou entre em contato com o suporte.
            </p>
            <div className="bg-white/5 p-4 rounded-sm border border-white/10 text-left overflow-auto max-h-40">
                <code className="text-xs text-pacces-gold/70">
                    {this.state.error?.message}
                </code>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="inline-block bg-pacces-gold text-pacces-ebony px-8 py-3 font-bold uppercase text-[12px] tracking-[0.2em] rounded-sm hover:bg-white transition-all duration-300"
            >
              Recarregar Página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
